import type { PropsWithChildren } from 'react';

import { Popover } from '~/components/Popover';

import { IconButton } from '../IconButton';
import type { IconButtonProps } from '../IconButton/IconButton';
import { KebabMenuItem } from './components/KebabMenuItem';

type IconButtonSize = NonNullable<IconButtonProps['size']>;
type IconButtonVariant = NonNullable<IconButtonProps['iconVariant']>;

export type KebabMenuProps = PropsWithChildren<{
  size?: IconButtonSize;
  iconVariant?: IconButtonVariant;
}>;

export function KebabMenuComponent({
  children,
  size = 'large',
  iconVariant = 'solid',
}: KebabMenuProps) {
  return (
    <Popover content={children} stopPropagation triggerAsChild>
      <IconButton
        aria-label="open options menu"
        iconType="ellipsis-vertical"
        size={size}
        iconVariant={iconVariant}
      />
    </Popover>
  );
}

KebabMenuComponent.displayName = 'KebabMenu';

export const KebabMenu = Object.assign(KebabMenuComponent, {
  Item: KebabMenuItem,
});
